import { render, staticRenderFns } from "./DeliveryRelated_Action.vue?vue&type=template&id=4f4bb132&"
import script from "./DeliveryRelated_Action.vue?vue&type=script&lang=js&"
export * from "./DeliveryRelated_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports